module.exports = __webpack_public_path__ + "static/img/Nic_Naitanui_mobile.eecb4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nic_Naitanui_mobile.jpg
// module id = io3E
// module chunks = 0